import { useToast, type Toast } from '#ui/composables';

type AppToast = Omit<Partial<Toast>, 'color'>;

export const useAppToast = () => {
	const toast = useToast();

	return {
		toasts: toast.toasts,
		error: (options: AppToast) => toast.add({ icon: 'i-lucide-circle-x', ...options, color: 'error' }),
		success: (options: AppToast) => toast.add({ ...options, color: 'success' }),
		info: (options: AppToast) => toast.add({ ...options, color: 'info' }),
	};
};
